import api from './api';

export const dateInviteService = {
   getAll: (params) => api.get('/date-invites', { params }).then((r) => r.data),
   delete: (id) => api.delete(`/date-invites/${id}`).then((r) => r.data),
};
